/*
 * @Author: xuejian3721
 * @Date: 2024-12-04 19:10:24
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-12-05 16:10:57
 */
/**
 * a标签下载文件
 * @param fileUrl  下载url
 * @param fileName  下载文件名
 * @constructor
 */
export function aTagDownload(fileUrl, fileName) {
  const a = document.createElement('a')
  a.href = fileUrl
  a.download = fileName || ''
  a.target = '_blank'
  console.log('ATagDownload---a', a)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function downloadFileFromUrl(url, fileName) {
  fetch(url)
    .then(res => res.blob())
    .then(blob => {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.target = '_blank'

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
    })
    .catch(error => console.error('下载失败:', error))
}

export function linkEnv() {
  // 环境变量判断
  let env
  switch (process.env.VUE_APP_PRODUCTION_ENV) {
    case 'production':
      env = ''
      break
    case 'fat':
      env = '.fat'
      break
    case 'pre':
      env = '.pre'
      break
    case 'test':
      env = '.test'
      break
    case 'uat':
      env = '.uat'
      break
    case 'tat':
      env = '.tat'
      break
    default:
      env = '.dev'
      break
  }
  return env
}

// 判断设备
export function getPlatformAgent() {
  const u = navigator.userAgent
  return {
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
    iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
    isWeChat: !!u.toLowerCase().match(/micromessenger/i), // 微信浏览器
    isMiniProgram: !!u.toLowerCase().match(/miniProgram/i), // 微信小程序或者支付宝小程序
    isHarmonyOS: !!u.toLowerCase().match(/OpenHarmony/i)
    // isInApp: u.indexOf('') >= 0
  }
}

// 判断环境
import dynamicLoadScript from './dynamicLoadScript'
const domain = window.location.host || document.domain
const domainArr = ['localhost', 'dev', 'test', 'uat', 'pre', 'cpre', 'npre','fat','tat']
const flag = domainArr.find(item => domain.indexOf(item) !== -1)
const URL =  flag ? 'https://fecdn.test.yyjzt.com/icon/third-dependency/yjj-user/dsBridge3.0.js' : 'https://fecdn.yyjzt.com/icon/third-dependency/yjj-user/dsBridge3.0.js'
export function loadHarmonyOS() {
  return new Promise((resolve) => {
    dynamicLoadScript(URL, function () {
      resolve()
    })
  })
}
